import { Box, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { FC } from 'react';
import Head from 'next/head';
import ImageBoxFuture from './image-box-future';
import { pxToRem } from '@/theme/typography';

export interface ErrorsPageProps {
  title: string;
  description: string;
  pageImage: string;
}

export const ErrorsPage: FC<ErrorsPageProps> = ({ title, pageImage, description }) => {
  const theme = useTheme();
  const intl = useIntl();
  return (
    <>
      <Head>
        <title>{intl.formatMessage({ id: title })}</title>
        {/* Every page built on this component is an error state — 404, unavailable, no data,
            500. None of them should be indexed, and a few are still reachable by URL. */}
        <meta name='robots' content='noindex, follow' />
      </Head>
      <Box
        component='div'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          pt: { tablet: pxToRem(96), mobile: '30px' },
          height: '100',
        }}
      >
        <ImageBoxFuture
          img={pageImage}
          title={intl.formatMessage({ id: title })}
          objectFit='contain'
          sx={{
            width: { tablet: pxToRem(288), mobile: '205px' },
            height: { tablet: pxToRem(165), mobile: '120px' },
            mb: { tablet: pxToRem(24), mobile: '24px' },
          }}
        />

        <Typography
          component='p'
          sx={{
            fontSize: { tablet: pxToRem(20), mobile: '16px' },
            textAlign: 'center',
            maxWidth: { tablet: pxToRem(461), mobile: '461px' },
            lineHeight: '150%',
            color: theme.palette.grey[50],
            fontWeight: 'bold',
          }}
        >
          <FormattedMessage id={description} />
        </Typography>
      </Box>
    </>
  );
};
